import I18n, { allowedLocales } from '~/i18n'

const LocaleService = {
    getAllowed() {
        return allowedLocales
    },

    get() {
        return I18n.locale
    },

    set(locale) {
        I18n.locale = locale
        // TODO: Specify locale in dayjs.
    },
}

export default LocaleService
